// extracted by mini-css-extract-plugin
export default {"form":"SearchBox_form__7XQfX","button":"SearchBox_button__9v3tj"};